import { render } from "./Parameters_0.vue?vue&type=template&id=0f18ac67"
import script from "./Parameters_0.vue?vue&type=script&lang=js"
export * from "./Parameters_0.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__